import { Inject, Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Resolve } from '@angular/router'
import { Observable, of, switchMap } from 'rxjs'
import { ResultsDataService } from '../results-data.service'
import { MultipleSectionsViewModel } from '@flocasts/experience-service-types'
import { LOGGER_SERVICE } from '../../logger/logger.config'
import { LoggerService } from '../../logger/logger.interface'
import {
  EXP_FLOWRESTLING_EVENT_HUB_BRACKETS_ID,
  EXP_FLOWRESTLING_EVENT_HUB_BRACKETS_VARIATION
} from 'src/app/shared/experimentation/experiment.model'
import { ExperimentationService } from 'src/app/shared/experimentation/experimentation.service'

@Injectable()
export class ResultsListResolver implements Resolve<MultipleSectionsViewModel | undefined> {
  public constructor(
    private readonly resultsApi: ResultsDataService,
    private readonly experimentationService: ExperimentationService,
    @Inject(LOGGER_SERVICE) private readonly logger: LoggerService
  ) {}

  resolve(route: ActivatedRouteSnapshot): Observable<MultipleSectionsViewModel | undefined> {
    return this.experimentationService
      .isInVariation(EXP_FLOWRESTLING_EVENT_HUB_BRACKETS_ID, EXP_FLOWRESTLING_EVENT_HUB_BRACKETS_VARIATION, true)
      .pipe(
        switchMap(isEventHubBracketsEnabled => {
          try {
            return this.resultsApi.getResultsIndexExperience(
              route.queryParams.search,
              route.queryParams.date,
              undefined,
              // Add the nav_id query param that is currently in the route
              // This must be done because this resolver code is running before the route has actually updated
              // Therefore our NavIdQueryParam interceptor would run, attempt to add the nav_id queryParam to our BFF request,
              // And add the incorrect (old) nav_id query param. This ensures we have the correct queryParams
              // by bypassing the interceptor when running the resolver
              route.queryParams.nav_id,
              isEventHubBracketsEnabled
            )
          } catch (error) {
            this.logger.error('Failed to get results index in resolver.', error)
            return of(undefined)
          }
        })
      )
  }
}
